import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import CatalogInput from './input';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { width: window.innerWidth };
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.inputs != this.props.inputs) {
            return true;
        }

        if (nextProps.filters != this.props.filters) {
            return true;
        }

        if (nextState.width >= 900 && this.state.width < 900) {
            return true;
        }

        if (nextState.width < 900 && this.state.width >= 900) {
            return true;
        }

        if (nextState.width >= 600 && this.state.width < 600) {
            return true;
        }

        if (nextState.width < 600 && this.state.width >= 600) {
            return true;
        }

        return false;
    }

    render({ inputs }) {
        if (inputs) {
            if (window.innerWidth > 599) { // tablet and desktop
                return (
                    <catalog-inputs>
                        <row className='is-wrap is-justified-center has-text-center has-padding-15-top'>
                            <column className='is-12'>
                                <CatalogInput input={inputs[0]} />
                            </column>
                        </row>
                        <row className='is-wrap is-justified-center has-margin-20-top'>
                            <column className='is-7 is-12-mobile has-padding-5-top'>
                                <CatalogInput input={inputs[1]} />
                            </column>
                            <column className='is-5 is-12-mobile'>
                                {this.renderSearch()}
                            </column>
                        </row>
                    </catalog-inputs>
                );
            }

            return (
                <catalog-inputs>
                    <div className='filters'>
                        <row className='is-wrap'>
                            <column className='is-12 has-text-center'>
                                <CatalogInput input={inputs[0]} />
                            </column>
                            <column className='is-12 has-padding-10-left'>
                                <CatalogInput input={inputs[1]} />
                            </column>
                        </row>
                    </div>
                    <row>
                        <column className='is-12'>
                            {this.renderSearch()}
                        </column>
                    </row>
                </catalog-inputs>
            );
        }

        return (<catalog-inputs />);
    }

    renderSearch() {
        return (
            <input
                type='search'
                name='search'
                placeholder='Search Products'
                value={this.props.filters.search || ''}
                onInput={this.handleKeyUp}
            />
        );
    }

    handleKeyUp = (e) => {
        this.props.setFilter({ ...this.props.filters, search: e.target.value });
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    }
}

const mapStateToProps = (state) => ({
    inputs: state.catalog && state.catalog.inputs,
    filters: state.catalog && state.catalog.filters,
});

const mapDispatchToProps = (dispatch) => ({
    setFilter: (payload) => dispatch({ type: 'catalog:set-filter', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
